(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.timer = null;
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      this.count = this.slides.length;
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = parseInt(this.dataset.autoplayInterval, 10) || 2000;
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      if (this.count <= 1) return;

      const prev = this.querySelector('[data-carousel-prev]');
      const next = this.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
      if (next) next.addEventListener('click', () => this.go(this.index + 1, true));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10), true));
      });

      // Pause autoplay while interacting / when tab hidden / on hover
      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      });

      // Basic touch swipe
      let startX = 0;
      this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; this.stop(); }, { passive: true });
      this.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) this.go(dx < 0 ? this.index + 1 : this.index - 1, true);
        this.start();
      }, { passive: true });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(target, userInitiated) {
      const newIndex = (target + this.count) % this.count;
      if (newIndex === this.index) return;

      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');

      this.slides[newIndex].classList.add('is-active');
      this.slides[newIndex].removeAttribute('aria-hidden');

      if (this.dots.length) {
        this.dots[this.index].classList.remove('is-active');
        this.dots[this.index].setAttribute('aria-selected', 'false');
        this.dots[newIndex].classList.add('is-active');
        this.dots[newIndex].setAttribute('aria-selected', 'true');
      }

      this.index = newIndex;

      // Reset autoplay timer after manual navigation
      if (userInitiated) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (!this.autoplay || this.reducedMotion || this.count <= 1) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1, false), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('hero-carousel')) {
    customElements.define('hero-carousel', HeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before_after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ba').forEach(function (section) {
      /* reveal */
      var reveals = section.querySelectorAll('.ba-reveal');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.12 });
        reveals.forEach(function (el) { io.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-in'); });
      }

      /* compare slider */
      var compare = section.querySelector('.ba-compare');
      if (!compare) return;
      var range = compare.querySelector('.ba-range');
      if (!range) return;
      function set(v) { compare.style.setProperty('--ba-pos', v); }
      range.addEventListener('input', function () { set(this.value); });
      set(range.value);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinically_measured"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

    function countUp(el, prefix, target, suffix, reduce) {
      if (reduce) { el.textContent = prefix + target + suffix; return; }
      if (el._raf) cancelAnimationFrame(el._raf);
      var dur = 850, t0 = null;
      function frame(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        el.textContent = prefix + Math.round(target * easeOut(p)) + suffix;
        if (p < 1) el._raf = requestAnimationFrame(frame);
      }
      el._raf = requestAnimationFrame(frame);
    }

    document.querySelectorAll('.cm').forEach(function (section) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* header reveal */
      var head = section.querySelector('.cm-reveal');
      if (head && 'IntersectionObserver' in window && !reduce) {
        var hio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); hio.unobserve(e.target); } });
        }, { threshold: 0.2 });
        hio.observe(head);
      } else if (head) {
        head.classList.add('is-in');
      }

      var slides = section.querySelectorAll('.cm-slide');
      if (!slides.length) return;

      var mobile = window.matchMedia('(max-width: 760px)').matches;
      var pin = section.getAttribute('data-pin') === 'true';

      if (mobile || reduce || !pin || !('IntersectionObserver' in window)) {
        if (!('IntersectionObserver' in window)) {
          slides.forEach(function (s) { s.classList.add('is-in'); });
          return;
        }
        var mio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            var s = e.target;
            s.classList.add('is-in');
            var num = s.querySelector('.cm-slide__num');
            if (num) countUp(num, s.dataset.prefix || '', parseInt(s.dataset.number, 10) || 0, s.dataset.suffix || '', reduce);
            mio.unobserve(s);
          });
        }, { threshold: 0.4 });
        slides.forEach(function (s) { mio.observe(s); });
        return;
      }

      /* desktop pinned: PAGE scroll slides the text strip (works anywhere, no scrollbar) */
      var track = section.querySelector('.cm__track');
      var stage = section.querySelector('.cm__stage');
      var strip = section.querySelector('.cm__strip');
      var ringWrap = section.querySelector('.cm__ring-wrap');
      var numEl = section.querySelector('.cm__num');
      var hint = section.querySelector('.cm__hint');
      var n = slides.length;
      var current = -1;
      var ticking = false;

      function activate(i) {
        if (i === current) return;
        current = i;
        var s = slides[i];
        slides.forEach(function (x, xi) { x.classList.toggle('is-current', xi === i); });
        if (ringWrap) ringWrap.style.setProperty('--cm-ring', s.dataset.ring || 0);
        if (numEl) countUp(numEl, s.dataset.prefix || '', parseInt(s.dataset.number, 10) || 0, s.dataset.suffix || '', reduce);
        if (hint) hint.style.opacity = i >= n - 1 ? '0' : '1';
      }

      function update() {
        ticking = false;
        // The mobile check above runs once at load. Without re-checking here,
        // rotating a phone into landscape kept driving the pinned scroll while
        // the CSS had already switched to the stacked layout, leaving a long
        // stretch of dead scroll.
        if (window.innerWidth <= 760) {
          if (strip) strip.style.transform = '';
          slides.forEach(function (s) { s.classList.add('is-in'); });
          return;
        }
        var dist = track.offsetHeight - window.innerHeight;
        var p = dist > 0 ? (-track.getBoundingClientRect().top) / dist : 0;
        p = Math.max(0, Math.min(1, p));
        var f = p * (n - 1);
        if (strip && stage) strip.style.transform = 'translateY(' + (-f * stage.clientHeight) + 'px)';
        activate(Math.round(f));
      }

      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs_custom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.faq').forEach(function (section) {
      /* reveal */
      var reveals = section.querySelectorAll('.faq-reveal');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { threshold: 0.12 });
        reveals.forEach(function (el) { io.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-in'); });
      }

      /* single-open behaviour */
      if (section.getAttribute('data-single') !== 'true') return;
      var items = section.querySelectorAll('.faq__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how_to_use"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.htu').forEach(function (section) {
      /* header reveal */
      var head = section.querySelector('.htu-reveal');
      if (head) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
            });
          }, { threshold: 0.15 });
          io.observe(head);
        } else {
          head.classList.add('is-in');
        }
      }

      /* scroll-pinned line draw */
      var pinEnabled = section.getAttribute('data-pin') === 'true';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var track = section.querySelector('.htu__track');
      var steps = section.querySelectorAll('.htu-step');
      if (!pinEnabled || reduce || !track || steps.length < 2) return;

      var enabled = false;
      var ticking = false;

      function update() {
        ticking = false;
        if (window.innerWidth <= 749) {
          if (enabled) { section.removeAttribute('data-animating'); enabled = false; }
          return;
        }
        if (!enabled) { section.setAttribute('data-animating', 'true'); enabled = true; }

        var dist = track.offsetHeight - window.innerHeight;
        var p = dist > 0 ? (-track.getBoundingClientRect().top) / dist : 1;
        p = Math.max(0, Math.min(1, p));
        section.style.setProperty('--htu-progress', p.toFixed(4));

        var n = steps.length;
        for (var i = 0; i < n; i++) {
          var threshold = n > 1 ? i / (n - 1) : 0;
          steps[i].classList.toggle('is-active', p >= threshold - 0.001);
        }
      }

      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_highlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('.hl-reveal');
    if (!els.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why_it_works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.wiw').forEach(function (root) {
      /* reveal on enter */
      if ('IntersectionObserver' in window) {
        var rio = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { root.classList.add('is-in'); rio.unobserve(root); } });
        }, { threshold: 0.15 });
        rio.observe(root);
      } else {
        root.classList.add('is-in');
      }

      var img = root.querySelector('.wiw__img');
      var tag = root.querySelector('.wiw__tag');
      var meta = root.querySelector('.wiw__meta');
      var desc = root.querySelector('.wiw__desc');
      var num = root.querySelector('.wiw__num');
      var numLabel = root.querySelector('.wiw__numlabel');
      var index = root.querySelector('.wiw__index');
      var tabs = [].slice.call(root.querySelectorAll('.wiw__tab'));
      if (!tabs.length) return;

      function select(el) {
        tabs.forEach(function (x) { x.classList.remove('is-on'); });
        el.classList.add('is-on');
        if (index) index.textContent = el.dataset.index || '';
        if (img) {
          img.style.opacity = 0;
          setTimeout(function () {
            if (el.dataset.img) { img.src = el.dataset.img; } else { img.removeAttribute('src'); }
            img.style.opacity = 1;
          }, 200);
        }
        if (tag) tag.textContent = el.dataset.tag || '';
        if (meta) meta.textContent = el.dataset.meta || '';
        if (desc) desc.textContent = el.dataset.desc || '';
        if (num) num.textContent = el.dataset.num || '';
        if (numLabel) numLabel.textContent = el.dataset.numlabel || '';
      }

      tabs.forEach(function (el) {
        el.addEventListener('click', function () { select(el); });
        el.addEventListener('mouseenter', function () { select(el); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
